import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { browserHistory } from 'react-router';
import PropTypes from 'prop-types';

import * as Actions from '../../models/user/actions';
import Store from '../../library/M2Store';

class SignIn extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            password: ''
        };
    }

    changeHandler(event) {
        let name = event.target.name;
        let current_state = this.state;
        if(typeof current_state[name] != "undefined") {
            current_state[name] = event.target.value;
            this.setState(current_state);
        }
    }

    submitHandler(event) {
        event.preventDefault();
        this.props.actions.authUser(this.state.email, this.state.password);
    }

    componentWillReceiveProps(p) {
        if(p && p.answer && p.answer.state) {
            if(p.answer.state == 'ERROR_AUTH_USER') {
                alert('Ошибка авторизации');
            }

        }
    }


    render() {

        let classNames = ['m2controller_va_block'];
        let loading = false;




        if(this.props.answer) {

            switch (this.props.answer.state) {
                case 'START_AUTH_USER': loading = true; break;
                case 'FINISH_AUTH_USER':
                    loading = true;
                    if(this.props.answer.data.access_token) {
                        for(var i in this.props.answer.data) {

                            Store.set(i, this.props.answer.data[i]);
                        }
                    }

                    if(this.props.answer.data.sources) {
                        Store.set('m2filter_sources', JSON.stringify(this.props.answer.data.sources));
                    }

                    // console.log(this.props.answer.data);


                    setTimeout(function(){
                        browserHistory.push('/feeds');
                    }, 1500);
                break;
            }
        }

        if(loading) {
            classNames.push('m2loader');
        }

        return (
            <div className="m2controller m2sign_in">
                <div className={classNames.join(' ')}>
                    <form className="m2form" method="POST" onSubmit={this.submitHandler.bind(this)}>
                        <div className="m2form__row">
                           <input placeholder="Email" type="email" name="email" value={this.state.email} onChange={this.changeHandler.bind(this)} />
                        </div>
                        <div className="m2form__row">
                            <input placeholder="Пароль" type="password" name="password" value={this.state.password} onChange={this.changeHandler.bind(this)} />
                        </div>
                        <div className="m2form__row m2form__buttons_row">
                            <button type="submit" className="m2btn m2btn__primary">Войти</button>
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    answer: state.UserReducer
});
const mapDispatchProps = dispatch => ({
    actions: bindActionCreators(Actions, dispatch)
});

export default connect(
    mapStateToProps,
    mapDispatchProps
)(SignIn);



// WEBPACK FOOTER //
// ./src/controllers/User/SignIn.js